export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/constant.js
// module id = 20
// module chunks = 0